import { useEffect } from 'react';
import Footer from '../../main-page/FooterMainPage/FooterMainPage.jsx';
import { useNavigate } from 'react-router';
import { Box, Button, Stack, Typography } from '@mui/material';
import { SystemStyleObject, Theme } from '@mui/system';
import { safeWindowOpen } from '~/helpers/safeUrlOpen.ts';
import docsInstructionProcessingPersonalManager from '~/assets/docs/instructions_processing_personal_data_manager.pdf';
import PersonalDataMainTable from './PersonalDataMainTable';
import { styles } from './styles';
import useGetUserRole from '~/hooks/useGetUserRole.js';

const PersonalDataMainPage = () => {
  const navigate = useNavigate();
  const {
    isPersonalDataManager,
    isPersonalDataObserver,
    isCallCenterOperator,
    isObserver,
    isManagerLogin,
  } = useGetUserRole();

  useEffect(() => {
    const isObserverOrOperator = isObserver || isCallCenterOperator;

    if (!isManagerLogin && !isObserverOrOperator && !isPersonalDataObserver) {
      navigate('/services');
    }
  }, [isPersonalDataObserver, navigate, isObserver, isCallCenterOperator, isManagerLogin]);

  const handleNavigateForm = () => navigate('/personal-data/application/new-by-manager');
  const openInstructionProcessingPersonalClient = () =>
    safeWindowOpen(docsInstructionProcessingPersonalManager);

  return (
    <Box sx={styles.root}>
      <Box component="main" sx={styles.main}>
        <Typography component="h2" variant="h4" sx={styles.title}>
          Обробка персональних даних
        </Typography>
        <Box sx={styles.contentContainer}>
          <Stack
            direction="row"
            spacing={2}
            sx={[
              styles.actions as SystemStyleObject<Theme>,
              { alignItems: 'center', justifyContent: 'flex-end' },
            ]}
          >
            <Button variant="outlined" onClick={openInstructionProcessingPersonalClient}>
              Інструкція
            </Button>
            {isPersonalDataManager && (
              <Button variant="contained" onClick={handleNavigateForm}>
                Створити заявку
              </Button>
            )}
          </Stack>

          <PersonalDataMainTable />
        </Box>
      </Box>
      <Footer />
    </Box>
  );
};

export default PersonalDataMainPage;
